import React from 'react'
import DateDisplay from 'src/components/DateDisplay'
import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import { EeocByCandidate } from 'src/queries'

interface ListProps {
  eeoc: EeocByCandidate | null | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { eeoc } = props
  const { createdAt, signedOn, status } = eeoc ?? {}

  const section: Array<Omit<ItemProps, 'id'>> = [
    {
      title: 'Status',
      value: (
        <span className='text-capitalize'>
          {status}
        </span>
      )
    },
    {
      title: 'Sent On',
      value: (
        <DateDisplay date={createdAt} display='system' />
      )
    },
    {
      title: 'Signed On',
      value: (
        <DateDisplay date={signedOn} display='system' />
      )
    }
  ]

  if (status === 'voided') {
    section.push({
      title: 'Voided On',
      value: (
        <DateDisplay date={eeoc?.voidedOn} display='system' />
      )
    })
    section.push({
      title: 'Void Reason',
      value: eeoc?.voidReason
    })
  }

  const dlProps = {
    className: 'row-cols-1',
    suspended: eeoc === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <DescriptionList {...dlProps}>
      {section.map(item => {
        const key = item.title.toLowerCase().replace(' ', '-')
        return <Item {...item} key={key} id={key} />
      })}
    </DescriptionList>
  )
}

export default List
